import { FONT_FAMILIES } from '@/constant';
import { SlideComponentLink } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentLinkCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentLink {
        return {
            id: id,
            type: 'link',
            pos: {
                x: 0,
                y: 0,
            },
            size: { width: 200, height: 50 },
            content: {
                label: {
                    id: crypto.randomUUID(),
                    type: 'text',
                    pos: {
                        x: 0,
                        y: 0,
                    },
                    size: { width: 0, height: 0 },
                    content: {
                        text: '',
                        fontSize: 16,
                        jyutping: [],
                        color: '#000000',
                        typeSettings: {
                            fontFamily: FONT_FAMILIES[0]?.fontFamily || 'Noto Sans SC',
                            formatting: ['underlined'],
                            alignment: 'center',
                            isPhonetic: false,
                            borderRadius: 0,
                            backgroundColor: 'transparent',
                        },
                    },
                },
                link: '',
            },
        };
    }
}
